/**
 * PREVENTION-ACTION.THUNK.TS
 * Custom endpoints
 */
import { createAsyncThunk } from "@reduxjs/toolkit"
import { PreventionAction, PreventionActionStatus } from "./prevention-action.types"
import preventionActionStore from "./prevention-action.store"
import { RootState } from "@/core/root-reducer"

/**
 * Create item
 */
//Rend la mesure creee (le serveur peut lui donner un autre id que le brouillon), null si l'ajout echoue
//Le type de retour est annote : sans lui, l'inference passe par le store et boucle sur lui-meme
export const add = createAsyncThunk<PreventionAction | null, PreventionAction>(
  "prevention-action/add",
  async (action, { dispatch }) => {
    if (action.PhysicalRiskId && action.EstablishmentId === null) {
      dispatch(preventionActionStore.actions.addMany([action]))
      dispatch(preventionActionStore.actions.setActive(null))
      return action
    }

    const response: PreventionAction = await dispatch(preventionActionStore.thunks.createEntity(action)).unwrap()
    if (!response) return null
    dispatch(preventionActionStore.actions.setActive(null))
    return response
  }
)

/**
 * Remove item
 */
export const remove = createAsyncThunk("prevention-action/remove", async (actionId: string, { dispatch }) => {
  const response = await dispatch(preventionActionStore.thunks.removeEntity(actionId)).unwrap()
  if (!response) return false
  return true
})

/**
 * Update the columns according the status and go to the next action plan
 */
export const updateStatus = createAsyncThunk(
  "prevention-action/status",
  async ({ status, goNext }: { status: PreventionActionStatus; goNext?: boolean }, { dispatch, getState }) => {
    const state = getState() as RootState
    const action = state.preventionAction.draft
    const risk = state.physicalRisk.active

    //Init date
    let dateStarted: null | Date = null
    let dateDone: null | Date = null

    if (status !== "todo") {
      dateStarted = action.dateStarted ?? new Date()
    }

    if (status === "done") {
      dateDone = action.dateDone ?? new Date()
    }

    //Update item
    dispatch(preventionActionStore.actions.edit({ key: "dateStarted", value: dateStarted }))
    dispatch(preventionActionStore.actions.edit({ key: "dateDone", value: dateDone }))

    //Edit object
    const response = await dispatch(preventionActionStore.thunks.updateEntity()).unwrap()

    //Go to the next item
    if (response && goNext) {
      const actions = preventionActionStore.selectors.listForRisk(state, risk.id).filter((x) => !x.dateDone)
      const currentIndex = actions.findIndex((a) => a.id === state.preventionAction.active.id)
      const nextAction = actions[currentIndex + 1]
      if (nextAction?.cStatus !== "done") {
        dispatch(preventionActionStore.actions.setActive(nextAction))
      } else {
        dispatch(preventionActionStore.actions.setActive(null))
      }
    }
  }
)
